import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../../../../../../redux/store";
import Header from "../../../../../../components/Header/Header";
import { visibleScrollbar } from "../../../../../../utils/functions/get-visible-scrollbar";
import { RightSidebar } from "./components/RightSidebar";
import { RightPanel } from "./components/RightPanel/RightPanel";
import { TicketOverview } from "./components/TicketOverview/TicketOverview";
import { TicketSearchBar } from "../TicketSearchBar";
import {
  useGetTicketQuery,
  useGetHelpdeskStagesQuery,
} from "../../../../../../redux/services/helpdeskApi";
import { SessionStorageUtil } from "../../../../../../utils/storage/storageUtils";
import { ANNOUNCEMENT_BANNER_DISMISSED_KEY } from "../../../../../../utils/constants/announcementBannerInfo";
import { getHelpdeskLabels } from "../../../../../../utils/constants/mappings";

export const TicketDetailsLayout = () => {
  const { ticketId = "" } = useParams();
  const region = useSelector(
    (state: RootState) => state?.auth?.client?.region
  );
  const helpdeskLabels = getHelpdeskLabels(region);

  const isBannerVisible =
    SessionStorageUtil.getItem(ANNOUNCEMENT_BANNER_DISMISSED_KEY) !== "true";

  const {
    data: ticketData,
    isLoading: isTicketLoading,
    refetch,
  } = useGetTicketQuery(ticketId, {
    skip: !ticketId,
  });
  const { data: stagesData } = useGetHelpdeskStagesQuery({});

  const [activeRightTab, setActiveRightTab] = useState("activity");

  const handleRightTabChange = (tab: string) => {
    setActiveRightTab(tab);
    if ((tab === "logs" || tab === "attachments") && ticketId) {
      void refetch();
    }
  };

  return (
    <>
      <Header>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[8px]">
            <h1 className="text-xl font-semibold text-verba-indigo dark:text-verba-indigo-dk">
              {helpdeskLabels.section}
            </h1>
            <hr className="border border-border-gray dark:border-border-gray-dk h-[16px] w-px" />
            <p className="text-md font-normal text-heading-text dark:text-heading-text-dk">
              {helpdeskLabels.ticketDetails}
            </p>
          </div>
          <TicketSearchBar />
        </div>
      </Header>
      <div
        className={`flex w-full ${isBannerVisible ? "h-[calc(100dvh-85px)]" : "h-[calc(100dvh-50px)]"} border-l border-t rounded-tl-[6px] border-border-gray dark:border-border-gray-dk overflow-x-auto overflow-y-hidden ${visibleScrollbar(
          "[&::-webkit-scrollbar]:h-[8px] [&::-webkit-scrollbar]:w-[8px]"
        )}`}
      >
        <TicketOverview
          ticketId={ticketId}
          ticketData={ticketData}
          stagesData={stagesData}
          isTicketLoading={isTicketLoading}
        />
        <RightPanel
          activeTab={activeRightTab}
          ticketData={ticketData}
          isTicketLoading={isTicketLoading}
          stagesData={stagesData}
        />
        <RightSidebar
          activeTab={activeRightTab}
          onTabChange={handleRightTabChange}
        />
      </div>
    </>
  );
};
